import { useModal } from "./Modal";
import Text from "./Text";

const SmallImage = ({
    src,
    alt = "",
    smallSize= "h-auto",
    classNames = "cursor-pointer rounded shadow-lg",
    largeClassNames = "w-auto h-auto max-h-fit",
    subtitle = ""
}) => {
    const { openModal, ModalView } = useModal();

    const openImage = () => {
        openModal(
            <img
                src={`/assets/${src}`}
                alt={alt}
                className={largeClassNames}
            />
        );
    };

    return (
        <div className="flex flex-col">
            <img
                src={`/assets/${src}`}
                alt={alt}
                className={`${classNames} ${smallSize}`}
                onClick={openImage}
            />
            <Text>{subtitle}</Text>
            <ModalView classNames="w-full h-full flex justify-center" modalColor="bg-black" />
        </div>
    );
};

export default SmallImage;
